import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar, EventSourceApi } from '@fullcalendar/core';
import { CalendarOpts } from "./calendar";

export function initCalMissions(cal: Calendar, opts: CalendarOpts) {
  p('initCalMissions');
  if (!opts.missions) return;

  const calendar = cal;
  Cookies.set('mission_activity_back', window.location.href, { path: '/' });
  Cookies.set('mission_activity_form_back', window.location.href, { path: '/' });
  Cookies.set('mission_report_back', window.location.href, { path: '/' });

  let source: EventSourceApi | null = null;
  let active = !(Cookies.get('cal_no_missions') == 'true');

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default margin-left-5px margin-bottom-5px toggle-calendar-missions',
    html: '<i class="fa fa-heartbeat"></i> Missziós'
  });
  $('#btnContainer').append(btn);
  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  // create button dynamically
  const btnNew = $('<button>', {
    class: 'btn btn-default margin-5px new-calendar-mission',
    html: '<i class="fa fa-heartbeat"></i> Új missziós tevékenység'
  });
  $('#btnNewContainer').append(btnNew);
  btnNew.on('click', function () {
    const newQuery = $("#modalNewEntry").data("new-query");
    window.location.replace("/mission_activities/new?" + newQuery);
  });

  refresh();

  function refresh() {
    active ? btn.addClass('active') : btn.removeClass('active');
    active ? $(btnNew).show() : $(btnNew).hide();
    Cookies.set('cal_no_missions', (!active) + '', {
      expires: 10,
      path: '/'
    });
    if (source) {
      active ? calendar.addEventSource(source) : source.remove();
    } else if (active) {
      source = calendar.addEventSource({
        url: '/mission_activities.json',
        extraParams: {
          'q[user_id_eq]': opts.user_id
        }
      });
    }
  }
}